import React , {useState , useEffect} from 'react'
import Breadcrumbs from '../../common/breadcrumb/Breadcrumbs'
import { getPayoutReports, getPayoutReportsExcel  , getPayoutReportsEnquiry } from '../../api/login/Login'
import { useParams } from 'react-router-dom'
import { Formik, Form, Field } from 'formik';
import { ToastContainer } from 'react-toastify'
import { message, Pagination ,Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx'; 
import Loadar from '../../common/loader/Loader'
import CustomInputField from '../../common/CustomInputField'

const breadCrumbsTitle = {
        id: "1",
        title_1: 'Reports',
        title_2:  'Payout Reports',
      }


const PayOutReport = () => {
    const [currentPage, setCurrentPage] = useState(0);
    const [count , setCount] = useState(10)
      const [data, setData] = useState(null);
      const [loading , setLoading] = useState(false)
    const [formKey, setFormKey] = useState(0);
    const [resetKey , setResetKey] = useState(false)
    const defaultInitialValues = {
        order_id : '',
        start_date: '',
        end_date: '',
        txn_id: '',
    };
    const resetValues = {
        order_id : '',
        start_date: '',
        end_date: '',
        txn_id: '',
    };
    const [initialValues, setInitialValues] = useState(defaultInitialValues);
 

    

     

        const handleReset = (resetForm) => {
            resetForm();
            setInitialValues(resetValues);
            setFormKey(prev => prev + 1); 
            setCurrentPage(0)
            setResetKey((pre)=>!pre)
            // getDmtTxnData(0); 
        };

        const handleSubmit = (values) => {
        
            setCurrentPage(0)
            setInitialValues(values)
            setResetKey((pre)=>!pre)
            // Add your API call here
        };

        const onChangeVal = (page) => {
            setResetKey((pre)=>!pre)
            setCurrentPage(page-1);
           
        };

  const getData = async () => {
    setLoading(true);
    try {
      const res = await getPayoutReports({ 
        ...initialValues, 
        page: currentPage, 
        count,
      
      });
      if (res && res.data) {
        setData(res);
      } else {
        setData(null);
        message.info('No data available');
      }
    } catch (error) {
      console.error("Error fetching DMT transaction data:", error);
      message.error('Failed to fetch transaction data. Please try again.');
      setData(null);
    } finally {
      setLoading(false);
    }
  };


    const downloadExcel = async () => {
      try {
        setLoading(true);
        const res = await getPayoutReportsExcel({
          ...initialValues,
         
        });
  
        if (res && res.data && res.data.length > 0) {
          const dataForExcel = res.data.map((item, i) => ({
  "Sr. No": i + 1,
  "User Name" : item?.user_name ,
  "Merchant Code" : item?.user_merchant_code,
   "Date / Time": item?.createdAt,
  "Account Holder Name": item?.account_name,
  "Transaction ID": item?.txn_id,
  "Batch ID": item?.batchId,
  "Bank Account Number": item?.bank_account_number,
  "Bank Name": item?.bank_name,
  "Bank IFSC": item?.bank_ifsc,
  "Amount": item?.amount,
  "Charge Amount": item?.charge_amount,
  "Opening Balance": item?.opening_balance,
  "Closing Balance": item?.closing_balance,
  "UTR": item?.utr,
  "Payment Mode": item?.paymentMode?.toUpperCase(),
  "Status": item?.status === 2 ? "Success" :
           item?.status === 1 ? "Pending" :
           item?.status === 3 ? "Failed" :
           item?.status === 4 ? "Refund" : "Unknown",
  "Status Message": item?.message,
  "Enquiry Log": item?.enqNumLog,
  "Num Log": item?.numLog
}));

  
          const ws = XLSX.utils.json_to_sheet(dataForExcel);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Payout_Report");
          XLSX.writeFile(wb, `Payout_Report ${new Date().toLocaleDateString()}.xlsx`);
        } else {
          message.error('No data available to export!');
        }
      } catch (error) {
        console.error("Error downloading Excel:", error);
        message.error('Failed to download Excel. Please try again.');
      } finally {
        setLoading(false);
      }
    };

       const responseEnquiry = async (id) => {
           setLoading(true); // Start loader before API call
           try {
               const res = await getPayoutReportsEnquiry(id);
              
               if (res?.data?.statusCode == "200") {
                   message.success(res?.data?.message || res?.message );
                   
               } else if (res?.data?.statusCode == "300") {
                   message.info(res?.message || res?.data?.message );
                  
               } else {
                   message.error(res?.message || res?.data?.message);
                   
               }
           } catch (error) {
               console.error("Error in payment enquiry:", error);
               message.error("An error occurred while processing your request");
           } finally {
               setResetKey((pre)=>!pre)
               setLoading(false); 
           }
       };


  useEffect(()=>{
    getData()
  },[resetKey , currentPage])
  return (
    <>
    { loading && <Loadar/> }
      <ToastContainer />

    
    <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />
    
    {/* // Filter Option // */}
    <div className="row m-4">
            <div className="col-xl-12">
                <div className="card">
                    <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1">
                            <div className="tbl-caption tbl-caption-2">
                                <h4 className="heading mb-0"><b>{breadCrumbsTitle.title_2} Search</b></h4>
                            </div>
                            <Formik
                                  key={formKey}
                                  initialValues={initialValues}
                                  onSubmit={handleSubmit}
                                enableReinitialize
                            >
                                {({ errors, touched, resetForm }) => (
                                    <Form className="tbl-captionn">
                                        <div className="row">
                                            <div className="col-xl-4 mb-3">
                                                <Field
                                                    as={CustomInputField}
                                                    type="date"
                                                    name="start_date"
                                                    placeholder="Start Date"
                                                    hasError={touched.start_date && errors.start_date}
                                                    errorMsg={errors.start_date}
                                                />
                                            </div>
                                            <div className="col-xl-4 mb-3">
                                                <Field
                                                    as={CustomInputField}
                                                    type="date"
                                                    name="end_date"
                                                    placeholder="End Date"
                                                    hasError={touched.end_date && errors.end_date}
                                                    errorMsg={errors.end_date}
                                                />
                                            </div>
                                           
                                            
                                           
                                            <div className="col-xl-4 mb-3">
                                                <Field
                                                    as={CustomInputField}
                                                    type="text"
                                                    name="txn_id"
                                                    placeholder="Transaction ID"
                                                    hasError={touched.txn_id && errors.txn_id}
                                                    errorMsg={errors.txn_id}
                                                />
                                            </div>
                                            <div className="col-xl-4 mb-3">
                                                <Field
                                                    as={CustomInputField}
                                                    type="text"
                                                    name="order_id"
                                                    placeholder="Order ID"
                                                    hasError={touched.order_id && errors.order_id}
                                                    errorMsg={errors.order_id}
                                                />
                                            </div>
                                            <div className="col-lg-12 col-md-12">
                                                <div className="d-flex justify-content-start">
                                                    <button className="btn btn-primary me-2" type="submit">
                                                        <i className="fas fa-search"></i> Search
                                                    </button>
                                                    <btn className="btn btn-secondary" type="button" onClick={() => handleReset(resetForm)}>
                                                        <i className="fas fa-refresh"></i> Reset
                                                    </btn>
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {/* // filter option end here  */}


    {/* // table section  */}
    {data?.data?.length > 0 ? (
        <>
         <section className="ListDistributer exppdf">
                <div className="row m-4">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1">
                                    <div className="tbl-caption">
                                        <h4 className="heading mb-0"><b>{breadCrumbsTitle.title_2} List</b></h4>
                                        <div className='d-flex'>
                                           
                                            <button onClick={downloadExcel} className='btn btn-primary border border-white'> <DownloadOutlined /> Download Excel</button>
                                        </div>
                                      

                                    </div>
                                       <div className="p-3">
                                    <h3 className="totalAmountstyle">Total Amount: <b>{data?.totalAmount || 0}</b></h3>
                                </div>
                                    <div id="empoloyees-tblwrapper_wrapper" className="dataTables_wrapper no-footer"> 
    <table id="table-to-xls" className="table dataTable no-footer" role="grid" aria-describedby="empoloyees-tblwrapper_info">
        <thead>
           <tr role="row">
  <th>Sr. No</th>
  <th>Date / Time</th>
  <th>User name</th>
  <th>Merchant Code</th>
  <th>Account Holder Name</th>
  <th>Transaction ID</th>
  <th>Batch ID</th>
  <th>Bank Account Number</th>
  <th>Bank Name</th>
  <th>Bank IFSC</th>
   <th>Opening Balance</th>
  <th>Amount</th>
  <th>Charge</th>
 
  <th>Closing Balance</th>
  <th>UTR</th>
  <th>Payment Mode</th>
  <th>Status</th>
  <th>Status Message</th>
  <th>Enquiry Log</th>
  <th>Num Log</th>
   <th>Enquiry</th>
</tr>
        </thead>
        <tbody>
            {data?.data?.map((item, i) => (
                <tr key={i} role="row" className="odd">
  <td>{(i + 1)+(currentPage*10)}</td>
  <td>{item?.createdAt}</td>
   <td>{item?.user_name}</td>
    <td>{item?.user_merchant_code}</td>
  <td>{item?.account_name}</td>
  <td>{item?.txn_id}</td>
  <td>{item?.batchId}</td>
  <td>{item?.bank_account_number}</td>
  <td>{item?.bank_name}</td>
  <td>{item?.bank_ifsc}</td>
   <td>₹{item?.opening_balance}</td>
  <td>₹{item?.amount}</td>
  <td>₹{item?.charge_amount}</td>
 
  <td>₹{item?.closing_balance}</td>
  <td>{item?.utr || ""}</td>
  <td>{item?.paymentMode?.toUpperCase()}</td>
  <td>
    {item?.status === 1 && <button className="btn btn-warning">Pending</button>}
    {item?.status === 2 && <button className="btn btn-success">Success</button>}
    {item?.status === 3 && <button className="btn btn-danger">Failed</button>}
    {item?.status === 4 && <button className="btn btn-light">Refund</button>}
  </td>
  <td>{item?.message}</td>
  <td>{item?.enqNumLog}</td>
  <td>{item?.numLog}</td>
                    <td><Button variant="outline-primary" onClick={() => responseEnquiry(item._id)}
                              disabled={loading || item?.status !== 1}>
                            Enquiry
                            </Button></td>
                </tr>
            ))}
        </tbody>
    </table>
</div>

                                </div>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div className="dataTables_info" id="empoloyees-tblwrapper_info" role="status" aria-live="polite">
                                        Total {data?.totalCount} entries
                                    </div>
                                    <div className="dataTables_paginate paging_simple_numbers" id="empoloyees-tblwrapper_paginate">
                                        <Pagination
                                            /* showSizeChanger
                                            onShowSizeChange={''} */

                                            // defaultCurrent={1}
                                            // onChange={onChangeVal}
                                            total={data?.totalCount}
                                            current={currentPage+1}
                                            onChange={onChangeVal}
 
                                        />
                                    </div>
                                </div>
                            </div>
                         
                        </div>

                    </div>

                </div >
            </section>
        </>
        ) : (
          <div className="text-center mt-4">
            <h3>No data available</h3>
          </div>
        )}
       {/* // table section  */}
    </>
  )
}

export default PayOutReport